// import "../styles/app.scss";
import "../fonts/OpenSans-Bold-webfont.eot"
import "../fonts/OpenSans-Regular-webfont.eot"
import "../fonts/OpenSans-Regular-webfont.woff2"
import "../fonts/OpenSans-Regular-webfont.woff"
import "../fonts/OpenSans-Regular-webfont.ttf"
import "../fonts/OpenSans-Bold-webfont.woff2"
import "../fonts/OpenSans-Bold-webfont.woff"
import "../fonts/OpenSans-Bold-webfont.ttf"
import "../fonts/OpenSans-Semibold-webfont.eot"
import "../fonts/OpenSans-Semibold-webfont.woff2"
import "../fonts/OpenSans-Semibold-webfont.woff"
import "../fonts/OpenSans-Semibold-webfont.ttf"


// SVGS
// function requireAll(r) {
//   r.keys().forEach(r);
// }
// const svg = requireAll(require.context("../svg/", true, /\.svg$/));
// const images = requireAll(require.context("../images/", true, /\.(png|jpe?g)$/));

document.addEventListener("DOMContentLoaded", function () {
  console.log('init project');
});
